"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Game = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var numeral_1 = __importDefault(require("numeral"));
var config_1 = require("../../config/config");
var GamesList_1 = require("./GamesList");
var Game = /** @class */ (function () {
    function Game(data) {
        var _this = this;
        this.getTopPrize = function () {
            if (_this.topPrizeHumanReadable) {
                return _this.topPrizeHumanReadable;
            }
            return _this.formatTopPrize();
        };
        this.formatTopPrize = function () { return numeral_1.default(_this.topPrize).format(config_1.react_core_config.internalConfig.currencyFormat); };
        this.id = data.id;
        this.description = data.description;
        this.gameId = data.gameId;
        this.gameTypeId = data.gameTypeId;
        this.lastModifiedDate = data.lastModifiedDate;
        this.lotteryId = data.lotteryId;
        this.name = data.name;
        this.playBegin = data.playBegin;
        this.playEnd = data.playEnd;
        this.playExpiry = data.playExpiry;
        this.progress = data.progress;
        this.retailPrice = data.retailPrice;
        this.state = data.state;
        this.tags = data.tags;
        this.ticketFullImage = data.ticketFullImage;
        this.ticketPosImage = data.ticketPosImage;
        this.topPrize = data.topPrize;
        this.topPrizeHumanReadable = data.topPrizeHumanReadable;
        this.overallOdds = data.overallOdds;
        this.isActive = !data.playEnd || moment_timezone_1.default().diff(moment_timezone_1.default(data.playEnd)) < 0;
        this.topPrizeType = data.topPrizeType;
        this.externalLink = data.externalLink;
        this.primaryColor = data.primaryColor;
        this.secondaryColor = data.secondaryColor;
        this.currency = data.currency;
        this.vendor = data.vendor;
        this.playForFun = data.playForFun;
        this.retailPriceMin = data.retailPriceMin;
        this.retailPriceMax = data.retailPriceMax;
    }
    Game.JsonToGames = function (data) {
        var gamesList = new GamesList_1.GamesList();
        data.forEach(function (game) { return gamesList.push(Game.JsonToGame(game)); });
        return gamesList.getDateStartSorted();
    };
    Game.JsonToGame = function (data) { return new Game(data); };
    Game.JsonToRelatedGames = function (data) {
        // @ts-ignore
        var gamesList = [];
        data.forEach(function (game) { return gamesList.push(Game.JsonToGame(game)); });
        // @ts-ignore
        return gamesList;
    };
    return Game;
}());
exports.Game = Game;
//# sourceMappingURL=Game.js.map